import { Search, Edit, Person } from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Button, GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel,InputWithLabel, SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance, DateFormatString, DialogType, FormActions, usuarioEntity } from "../../utils/constants";
import * as yup from "yup";
import { ModalFormGenerador } from "../../components/form/ModalForm";




const schema = yup.object({
  compania:yup.string().required(),
  cod_erp:yup.string().max(4).nullable().notRequired(),
  usuario: yup.string().required(),
  razon_social: yup.string().required(),
  celular: yup.string().required(),
  email: yup.string().email().required(),
  pass: yup.string().optional(),
  perfil: yup.number().required(),
  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional(),
  agente_asociado: yup.object().optional().notRequired().nullable(),
  centro_op_destinos: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional().notRequired().nullable(),
  activo: yup.string().required(),
  cod_tipo_identificacion:yup.string().required(),
  nro_identificacion:yup.string().required()
}).required();



const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  filter_search:""
};

const mapUsuarioDetalleToForm = (product) => {
  const productos = Array.isArray(product.productos_asociados) ? product.productos_asociados : [];
  const centrosDestino = Array.isArray(product.centro_op_destinos) ? product.centro_op_destinos : [];

  const mapped = {
    ...product,
    perfil: product.cod_perfil,
    activo: product.ind_estado,
    compania: product.cod_cia,
    cod_erp: product.cod_erp_vendedor,
    agente_asociado: product.cod_agente
      ? { value: product.cod_agente, label: product.nombre_agente }
      : null,
    productos_asociados: productos.map((product_aso) => ({
      label: product_aso.descripcion || product_aso.label,
      value: product_aso.cod || product_aso.value,
    })),
    centro_op_destinos: centrosDestino.map((centro) => ({
      label: centro.label,
      value: centro.value,
    })),
  };

  delete mapped.clave;
  return mapped;
};

export const MaestrosUsuarios = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [roles,setRoles] = useState([]);
  const [companiasList,setCompaniasList] = useState([]);
  const [productosOptions,setProductosOptions] = useState([]);
  const [proveedorOptions,setProveedorOptions] = useState([]);
  const [clienteOptions,setClienteOptions] = useState([]);
  const [agentesOptions,setAgentesOptions] = useState([]);
  const [centrosOp,setCentrosOp] = useState([]);
  const [centrosOpDestino,setCentrosOpDestino] = useState([]);
  const [tiposDocumentacion,setTiposDocumentacion] = useState([]);
  



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
     // await loadItems(false);
      await loadRoles();
      await loadCompany();
      await loadTiposDocumentos();
     

      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }
    
    const loadRoles = async()=>{
      const  {data:{value}} = await AxiosInstance.get("maestros/listar_perfiles");
      setRoles(value);
    }
    const loadCompany = async()=>{
      const  {data:{value}} = await AxiosInstance.get("maestros/listar-companias");
      setCompaniasList(value);
    }
        
    const loadTiposDocumentos = async()=>{
      const  {data:{value}} = await AxiosInstance.post("logistico/obtener-tipos-identificacion");
      setTiposDocumentacion(value);
    }
    const loadCentrosOp = async(search)=>{
      const  {data:{value}} = await AxiosInstance.get("Sucursales/obtener-centros-operacion?search="+search);
      return value;
    }


    const loadItems =  async (loading=true)=>{
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/obtener-usuarios-paginacion",{
      ...filterSearchPagination,
      page_number:filterSearchPagination.page_number+1
     });
     setDataSetProductos([...value?.data]);

     setTotalRows(value?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

    const onSearchProductByName = (evt)=>{
      
      setFilterSearchPagination({...InitialFilterSearch,filter_search:evt.target.value});
    }

    const fetchUsuarioDetalle = async (cod) => {
      const { data: { value } } = await AxiosInstance.get(`maestros/obtener-usuario/${cod}`);
      return value;
    };

    const onShowDetailProduct = async (cod_prod) => {
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true,
      });
      try {
        const product = await fetchUsuarioDetalle(cod_prod);
        const mapped = mapUsuarioDetalleToForm(product);
        setProductoSeleccionado(mapped);
        setProductosOptions([...mapped.productos_asociados]);
        setTipoAction(FormActions.MODIFICAR);
        setIsVisibleModalDetalle(true);
      } catch (err) {
        dispatch({
          type: ActionTypes.setModalInfo,
          data: {
            title: "Error",
            message: "No se pudo cargar el detalle del usuario",
            type: DialogType.peligro,
            isVisible: true,
          },
        });
      } finally {
        dispatch({
          type: ActionTypes.setLoadingPage,
          data: false,
        });
      }
    };

    const onShowExternoModal = () => {
      dispatch({
        type: ActionTypes.setModalInfo,
        data: {
          title: "Funcionalidad descontinuada",
          message:
            "La configuración de usuario externo (planos / impodatos) ya no está disponible. El envío de documentos al ERP se realiza por el servicio central.",
          type: DialogType.peligro,
          isVisible: true,
        },
      });
    };

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }
    const onSaveDataForm = async(typeAction,dataForm)=>{
    
      const urlService = typeAction === FormActions.AGREGAR?'maestros/agregar-usuario-and-products':'maestros/editar-usuario-and-products/'+dataForm.cod;
 
        let payload =  {
          compania:dataForm.compania,
          usuario:dataForm.usuario,
          cod_erp:dataForm.cod_erp,
          razon_social:dataForm.razon_social,
          celular:dataForm.celular,
          clave:dataForm.pass,
          email:dataForm.email,
          perfil:dataForm.perfil,
          ind_factura_electronica:dataForm.ind_factura_electronica,
          agente_asociado:dataForm.agente_asociado?.value,
          productos:dataForm.productos_asociados.map(prod=>prod.value),
          cod_proveedor:dataForm.proveedor_asociado?.value,
          cod_cliente:dataForm.cliente_asociado?.value,
          activo:dataForm.activo,
          centro_op_asociado:dataForm.centro_op_asociado?.value,
          centro_op_destinos:dataForm.centro_op_destinos?.map(item=>item.value),
          cod_tipo_identificacion:dataForm.cod_tipo_identificacion,
          nro_identificacion:dataForm.nro_identificacion
        };
      

        setIsVisibleModalDetalle(false);
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
        AxiosInstance.post(urlService,payload)
        .then(async res=>{
          setIsVisibleModalDetalle(false);
         await loadItems(true);
        })
        .catch(err=>{
          dispatch({
            type:ActionTypes.setModalInfo,
            data:{
                title:"Error",
                message:"Error de comunicacion verifique su conexion a internet",
                type:DialogType.peligro,
                isVisible:true
            }
        });
        }).finally(()=>{
          dispatch({
            type:ActionTypes.setLoadingPage,
            data:false
          });
        });
       
     

    }

    
    const onSearchCliente = async (evt,value_search) => {

      if (value_search && value_search.length > 2  && value_search.length %2 === 0 ) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros-marketplace/get-clientes-filtro", {
            text_search: value_search
          });
          setClienteOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
    }
    const onSearchProveedor = async (evt,value_search) => {

      if (value_search && value_search.length > 2  && value_search.length %2 === 0 ) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-prov-by-filter", {
            search_query: value_search
          });
          setProveedorOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }
    const onSearchAgente = async (evt,value_search) =>{

      if (value_search) {

         try{

          const { data: { value } } = await AxiosInstance.post("maestros/filtrar-agentes", {
            search: value_search
          });
          setAgentesOptions(value);
          return value;
         }catch(e){
          return [];
         }
  
      }
  
  
  
    }

    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }

    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductosOptions(res);
      } catch (e) {
  
      }
    }
    const searchCpAsociado = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOp(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }
    const searchCpDestino = async (event, newInputValue) => {
      let value =  await loadCentrosOp(newInputValue.toLowerCase());
      setCentrosOpDestino(value.map(cp_obj=>({label:cp_obj.descripcion,value:cp_obj.cod})));
    }

  
    const columnsTable = [
      {
      
       key:"cod",
       keyValue:"cod",
       label:"ID",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
      {
      
        key:"label_compania",
        keyValue:"label_compania",
        label:"Compañia",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
     
      {
      
        key:"usuario",
        keyValue:"usuario",
        label:"Nombre",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"email",
        keyValue:"email",
        label:"Correo",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"razon_social",
        keyValue:"razon_social",
        label:"Razon social",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_creacion",
        keyValue:"fecha_creacion",
        label:"F. creacion",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>dayjs(props.value).format(DateFormatString),
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"perfil_nombre",
        keyValue:"perfil_nombre",
        label:"Rol",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },

       {
      
        key:"ind_estado",
        keyValue:"ind_estado",
        label:"Activo",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
        {
        key:"editar",
        keyValue:"cod",
        label:"Editar",
        headerRender:(props)=>props.label,
        bodyRender:({value})=><Button size="small" onClick={e=>onShowDetailProduct(value)} variant="contained" startIcon={<Edit/>} >Editar</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },  
       {
        key:"usuario_externo",
        keyValue:"usuario_externo",
        label:"US externo",
        headerRender:(props)=>props.label,
        bodyRender:()=><Button size="small" color="secondary" onClick={onShowExternoModal} variant="contained" startIcon={<Person/>} >U.E</Button>,
        typeRow:"number",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
      },  
    ];
   
    const configModal =  {
      titleModal: tipoAction === FormActions.AGREGAR? "Agregar usuario":'Modificar usuario',
      buttomsAction: tipoAction === FormActions.AGREGAR? [
          {
            title:"Cancelar",
            buttomProps:{
              type:"buttom",
              onClick:()=>setIsVisibleModalDetalle(false),
              color:"secondary"
          }
          },
          {
            title:"Registrar",
            buttomProps:{ 
              type:"submit",
             // onClick:onSaveDataNewData
            }
          }
      ]:[
        {
          title:"Cancelar",
          buttomProps:{
            type:"buttom",
            color:"secondary",
            onClick:()=>setIsVisibleModalDetalle(false)
          }
        },
        {
          title:"Guardar cambios",
          buttomProps:{
            type:"submit",
          //  onClick:onSaveModData
          }
        }

      ],
      imputs:[
        {
          key:"compania",
          keyValue:"compania",
          label:"Compañia",
          responsiveSize:7,
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:companiasList
          }
        },
        {
          key:"cod_erp",
          keyValue:"cod_erp",
          label:"CODIGO ERP (OPCIONAL)",
          responsiveSize:5,
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"usuario",
          keyValue:"usuario",
          label:"Nombre completo",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"razon_social",
          keyValue:"razon_social",
          label:"Razon social",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        },
        {
          key:"cod_tipo_identificacion",
          keyValue:"cod_tipo_identificacion",
          label: "Tipo de documento",
          component:SelectInputWithLabel,
          inputProps:{
            size:"small",
            type:"text",
            items:tiposDocumentacion,
           
           
          }
        },
        
        {
          key:"nro_identificacion",
          keyValue:"nro_identificacion",
          label: "Numero de documento",
          component:InputWithLabel,
          inputProps:{
            size:"small",
            type:"text",
    
          }
        },
        {
          key:"celular",
          keyValue:"celular",
          label:"Celular",
          component:InputWithLabel,
          inputProps:{
            type:"number",
            size:"small"
          }
        },
        {
          key:"email",
          keyValue:"email",
          label:"Correo",
          component:InputWithLabel,
          inputProps:{
            type:"email",
            size:"small"
          }
        },
        {
          key:"pass",
          keyValue:"pass",
          label:"Clave",
          component:InputWithLabel,
          inputProps:{
            type:"text",
            size:"small"
          }
        }, 
        {
          key:"perfil",
          keyValue:"perfil",
          label:"Rol",
          component:SelectInputWithLabel,
          inputProps:{
            type:"text",
            size:"small",
            items:roles
          }
        },
        {
          key: "proveedor_asociado",
          keyValue: "proveedor_asociado",
          label: "Proveedor asociado",
          component: AutoCompleteInputWithLabel,
          responsiveSize:6,
          inputProps: {
            name: 'Proveedor',
            size:"small",
            fullWidth: true,
            isLoading: false,
            multiple:false,
            onInputChange: onSearchProveedor,
            options: proveedorOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        }, 
        {
          key: "agente_asociado",
          keyValue: "agente_asociado",
          label: "Agente asociado",
          component: AutoCompleteInputWithLabel,
          responsiveSize:6,
          inputProps: {
            name: 'agente_asociado',
            size:"small",
            fullWidth: true,
            isLoading: false,
            multiple:false,
            onInputChange: onSearchAgente,
            options: agentesOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        }, 
        {
          key: "cliente_asociado",
          keyValue: "cliente_asociado",
          label: "Cliente asociado",
          component: AutoCompleteInputWithLabel,
          responsiveSize:6,
          inputProps: {
            name: 'cliente_asociado',
            size:"small",
            fullWidth: true,
            isLoading: false,
            multiple:false,
            onInputChange: onSearchCliente,
            options: clienteOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        }, 
        {
          key: "productos_asociados",
          keyValue: "productos_asociados",
          label: "Productos asociados",
          component: AutoCompleteInputWithLabel,
          responsiveSize:12,
          inputProps: {
            size:"small",
            name: 'productos_asociados',
            fullWidth: true,
            isLoading: false,
            multiple:true,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searcProductoAsociado,
            options: productosOptions || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },
        {
          key: "centro_op_asociado",
          keyValue: "centro_op_asociado",
          label: "Centro de operacion mas cercano",
          component: AutoCompleteInputWithLabel,
          responsiveSize:6,
          inputProps: {
            size:"small",
            name: 'centro_op_asociado',
            fullWidth: true,
            isLoading: false,
            multiple:false,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searchCpAsociado,
            options: centrosOp || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },
        {
          key: "centro_op_destinos",
          keyValue: "centro_op_destinos",
          label: "Centros de operacion Destino",
          component: AutoCompleteInputWithLabel,
          responsiveSize:6,
          inputProps: {
            size:"small",
            name: 'centro_op_asociado',
            fullWidth: true,
            isLoading: false,
            multiple:true,
            PopperComponent:(props)=><div hidden={!props.open} >
             
               {props.children}
            </div>,
            onInputChange: searchCpDestino,
            options: centrosOpDestino || [],
            noOptionsText: "Lista vacia",
            getOptionLabel: (option) => option.label,
            isOptionEqualToValue: (option, value) => option.value === value.value,
            filterOptions:(x) => x,
          }
        },

        {
          key:"activo",
          keyValue:"activo",
          label:"Estado",
          component:SelectInputWithLabel,
          inputProps:{
            size:"small",
            items:[
              {
                value:"ACTIVO",
                label:"Activo"
              },
              {
                value:"INACTIVO",
                label:"Inactivo"
              },
              {
                value:"POR CONFIRMAR",
                label:"Por confirmar"
              }
            ],
            type:"select",
       
          }
        },
        {
          key:"ind_factura_electronica",
          keyValue:"ind_factura_electronica",
          label:"¿Emite factura electronica?",
          component:SelectInputWithLabel,
          inputProps:{
            size:"small",
            items:[
              {
                value:"SI",
                label:"SI"
              },
              {
                value:"NO",
                label:"NO"
              },
             
            ],
            type:"select",
       
          }
        },
        
      ],
      arrayInputs:[]
    } ;


    return (<>
    {
      isVisibleModalDetalle &&
    <ModalFormGenerador 
    isVisible={isVisibleModalDetalle}
    schemaValidator={schema}
    entityValues={productoSeleccionado}
    {
      ...configModal
    }
    onSendForm={onSaveDataForm}
    typeAction={tipoAction}
    />
    }

    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={4} >

            <InputWithLabel
              label="Buscar usuario"
            
              onChange={onSearchProductByName}
              endAdornment={<Search />}
            />
        

        </Grid>
        <Grid item sm={12} xs={12} md={12} >
          <Button variant="contained" color="primary" onClick={e=>onOpenModalItem(false)} >Nuevo usuario</Button>
        </Grid>
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}